import FormPropertyAdditionalPrice from './FormPropertyAdditionalPrice';

export default FormPropertyAdditionalPrice;
